import React, { useEffect, useState } from "react";
import { ImageVariant, ImageView } from "common/views/image/Image.view";
import { ButtonVariant, ButtonView } from 'common/views/button/Button.view';
import labelProvider from './FeaturedItems.labels';
import { BlockVariant, BlockView } from 'common/views/block/BlockView.view';
import HeadingView from 'common/views/heading/Heading.view';
import { DialogView } from "common/views/dialog/Dialog.view";
import { Variant } from "panels/catalog/entities/Course";
import RenderVariants from "panels/catalog/fragments/renderVariants";
import CatalogLabels from "panels/catalog/Catalog.labels";


const { Labels } = labelProvider;

// status
export const status = {
	name: "Status",
	label: { k: "course.status", v: "Status" },
	component: ({ item }) => (
		<BlockView variant={BlockVariant.CARD_CONTENT} viewKey="course-status" key="course-status">
			<HeadingView viewKey="course-status-label">
				<Labels.CourseStatus />
			</HeadingView>
		 	<HeadingView  viewKey="course-status" children={item && item.status} />
		</BlockView>
	
	),
};

// Lunch
export const launchCourse = {
	name: "Launch Course",
	label: { k: "course.launchCourse", v: "Launch" },
	component: ({ item }) => {
		if (item.canLaunch) {
		return (<ButtonView key="launchLink" variant={ButtonVariant.PRIMARY} viewKey="launch.link" onClick={()=>item.lunchFunction()}>
			<Labels.Launch />
		</ButtonView>)
		}
		return null;
	},
};
export const buy = {
	name: "Buy",
	label: {k: "course.buy", v: "Purchase"},
	enabled: ({course}) => !course || (course && course.canBuy), // skeleton when loading, hide if loaded and not buyable
	component: ({ course, actions, disableDirectBuy, loginBeforeBuy }) => {
		const [isOpen, toggleOpen] = useState(false);
		const [variants, setVariants] = useState([]);


		const _onclickHandler = () => {
			if (variants.length === 1)
				actions.addToCart(course, variants[0], disableDirectBuy, loginBeforeBuy);
			else
				toggleOpen(true);
		}

		useEffect(() => {
			//here filtering variants
			if (course && course.variants && course.variants.length > 0) {
				const variantList = course.variants.filter(variant => !variant.repurchaseVariant && (course.canBuy || variant.price > 0) && !variant.displayOnly)
				setVariants(variantList);
			}

		}, [course])

		return (
			course && variants && variants.length > 0 &&
			<React.Fragment>
				<DialogView isOpen={isOpen} viewKey="dialog" onClosed={() => toggleOpen(!isOpen)}>
					<RenderVariants variants={variants}
						addTocart={(v: Variant) => actions.addToCart(course, v, disableDirectBuy, loginBeforeBuy)}
						toggleOpen={() => toggleOpen(!isOpen)}
						isRepurchase={false} />
				</DialogView>
				<ButtonView
					variant={ButtonVariant.PRIMARY}
					viewKey="catalog.buyCourse"
					onClick={() => _onclickHandler()}
				>
					{variants.length == 1 ?
						(<CatalogLabels.Labels.BuyCourse args={{ price: variants[0].price, title: variants[0].title }} />)
						: <p>Add to Cart</p>
					}
				</ButtonView>
			</React.Fragment>
		)
	}
};


// clickable image
export const FeaturedActionImage = {
	name: "Featured Action Image",
	label: {k: "course.featuredActionImage", v: "fwImage"},
	component: ({course, imageURL}) => {
		return (
			<div style={{position: "relative"}}>
				<ImageView
					src={course && (imageURL || course.iconUrl || course.smallIconUrl)}
					overlay={course && course.productType && {
						src: course.productType.iconUrl,
						position: "top left"
					}}
					variant={ImageVariant.THUMBNAIL}
					viewKey="course.image.actions"
				/>
			</div>
		);
	}
};




// WEBPACK FOOTER //
// ./src/panels/featuredItems/displayFragments.tsx